// Generated by CoffeeScript 2.7.0
var YetAnotherWorkflow;

import Vertex from './vertex.js';

import Edge from './edge.js';

import Graph from './graph.js';

import Flow from './flow.js';

import Condition from './condition.js';

import Journey from './journey.js';

import Assignment from './assignment.js';

export default YetAnotherWorkflow = {Vertex, Edge, Graph, Flow, Condition, Journey, Assignment};
